/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import React, { DetailedHTMLProps } from 'react';
import Icon from '@ant-design/icons';
import { IconComponentProps } from '@ant-design/icons/lib/components/Icon';

type ImgProps = Omit<
  DetailedHTMLProps<React.ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>,
  'src' | 'alt'
>;

export const createImg = (src: string, alt: string) => {
  return (props: ImgProps) => {
    return <img src={src} alt={alt} {...props} />;
  };
};
export const createIcon =
  (rawIcon: IconComponentProps['component']) => (props: IconComponentProps) =>
    <Icon component={rawIcon} {...props} ref={undefined} />;
